/**
 * Put 360 spin second (after first still image).
 * Product Sirv uses autostart:off so this can register before Sirv.start().
 *
 * Thumbnail arrows are built in. They appear when the left-hand strip is
 * shorter than the thumbnail list, so that strip is kept to the image height.
 * The limit lives on the product gallery, so it does not follow the viewer
 * into fullscreen.
 */
(function () {
  function thumbnailItems(box) {
    return Array.prototype.filter.call(box.querySelectorAll('.smv-scroll > .smv-item'), function (item) {
      return !item.hasAttribute('disabled') && item.offsetHeight > 0;
    });
  }

  function clearThumbLimit(root) {
    if (!root.style.getPropertyValue('--sirv-thumb-limit')) return false;
    root.style.removeProperty('--sirv-thumb-limit');
    return true;
  }

  function limitThumbnails(root) {
    var box = root.querySelector('.smv-selectors-box');
    var slides = root.querySelector('.smv-slides-box');
    if (!box || !slides) return false;

    if (!box.classList.contains('smv-v')) return clearThumbLimit(root);

    var imageHeight = Math.round(slides.getBoundingClientRect().height);
    var items = thumbnailItems(box);
    if (!imageHeight || items.length < 2) return clearThumbLimit(root);

    var contentHeight = 0;
    for (var i = 0; i < items.length; i++) contentHeight += items[i].offsetHeight;
    if (contentHeight <= imageHeight) return clearThumbLimit(root);

    var next = imageHeight + 'px';
    if (root.style.getPropertyValue('--sirv-thumb-limit') === next) return false;

    root.style.setProperty('--sirv-thumb-limit', next);
    return true;
  }

  function limitAllThumbnails() {
    var changed = false;
    document.querySelectorAll('.sirv-product-media').forEach(function (root) {
      if (limitThumbnails(root)) changed = true;
    });
    if (changed) window.dispatchEvent(new Event('resize'));
  }

  function watchThumbnails() {
    if (window.__sirvThumbLimitBound) return;
    window.__sirvThumbLimitBound = true;

    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        limitAllThumbnails();
      });
    }

    window.addEventListener('resize', schedule);

    if (window.MutationObserver) {
      var observer = new MutationObserver(schedule);
      document.querySelectorAll('.sirv-product-media').forEach(function (root) {
        observer.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }

    schedule();
  }

  function start() {
    if (!window.Sirv || !Sirv.viewer || !Sirv.viewer.filters) return false;

    if (!window.__sirvSpinFilterBound) {
      window.__sirvSpinFilterBound = true;
      Sirv.viewer.filters.add(function (viewerId, items) {
        if (!items || !items.length) return items;

        var spins = [];
        var rest = [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].type === 'spin') spins.push(items[i]);
          else rest.push(items[i]);
        }

        if (!spins.length || !rest.length) return items;
        return [rest[0]].concat(spins, rest.slice(1));
      });
    }

    Sirv.start('.sirv-product-media .Sirv');
    watchThumbnails();
    document.dispatchEvent(new CustomEvent('product:sirv-started'));
    return true;
  }

  if (start()) return;

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    if (start() || attempts > 40) clearInterval(timer);
  }, 100);
})();
